import { ElementRef, Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare var $: any;
declare function rw(): any;
declare function formCarousel(): any;
declare function cardsSectionWidth(): any;
declare function dropdownInputFilter(): any;

@Injectable({
  providedIn: 'root'
})
export class ScriptService {

  private renderer: Renderer2;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  documentReady() {

    if (!isPlatformBrowser(this.platformId))
      return;

    rw();

    setTimeout(() => {
      formCarousel();
    }, 200);

    cardsSectionWidth();

    $(window).resize(function () {
      rw();
      cardsSectionWidth();
    });
  }

  showToastSuccess() {
    if (!isPlatformBrowser(this.platformId))
      return;

    $(".toast-success").toast({ autohide: true, delay: 3000 });
    $(".toast-success").toast("show")
  }

  showToastError() {
    if (!isPlatformBrowser(this.platformId))
      return;

    $('.toast-danger').toast({ autohide: true, delay: 3000 });
    $('.toast-danger').toast('show');
  }

  initFilterInputJs() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $('.filter-input').keyup(dropdownInputFilter);
  }

  showFilterSearchSection() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    //    if (!($('#filter-search-section ').length > 0))
    //      return;

    var wWidth = $(window).innerWidth();



    if (wWidth < 768) {
      $('#filter-search-section').collapse('hide');
    }

    if (768 <= wWidth) {
      setTimeout(() => {
        $('#filter-search-section').collapse('show');
      }, 1000);
    }

    $(window).resize(function () {
      var wWidth = $(window).innerWidth();

      if (window.innerWidth != wWidth && wWidth < 768) {
        $('#filter-search-section').collapse('hide');
      }

      if (768 <= wWidth) {
        $('#filter-search-section').collapse('show');
      }
    });
  }

  initPopover() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    setTimeout(() => {
      $(function () {
        $('[data-toggle="popover"]').popover({ boundary: 'window', html: true });
      });
    }, 100);
  }

  initCarouselStep(carouselName: string, isAddClassTransition: boolean = true) {
    setTimeout(() => {

      $('#' + carouselName).carousel({
        interval: false,
        touch: false,
        keyboard: false,
        ride: false
      });

      $(`#${carouselName}`).on('slide.bs.carousel', function (e) {

        var indexToSlide = e.to;
        var slideDirection = e.direction;
        var newStep = indexToSlide + 1;
        var oldStep = indexToSlide;

        if (isAddClassTransition)
          $('.carousel-inner').addClass('transition-carousel-inner');

        if (slideDirection === 'left') {
          $('.form-steps .step:nth-child(' + oldStep + ')').removeClass('active').addClass('ok');
          $('.form-steps .step:nth-child(' + newStep + ')').addClass('active');
        }

        if (slideDirection === 'right') {
          $('.form-steps .step:nth-child(' + (oldStep + 1) + ')').addClass('active').removeClass('ok');
          $('.form-steps .step:nth-child(' + (newStep + 1) + ')').removeClass('active ok');
        }
      });
    }, 100);
  }

  initCustomDisabledEvents() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $('.custom-disabled-events').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  initCarouselStepShotcut(carouselName: string, maxSteps: number) {
    setTimeout(() => {

      $(`#${carouselName}`).on('slide.bs.carousel', function (e) {

        var indexToSlide = e.to;
        var slideDirection = e.direction;
        var newStep = indexToSlide + 1;
        var oldStep = indexToSlide;

        $('.carousel-inner').addClass('transition-carousel-inner');

        if (slideDirection === 'left') {

          while ((oldStep > 0)) {
            $('.form-steps .step:nth-child(' + oldStep + ')').removeClass('active').addClass('ok');
            oldStep--;
          }

          $('.form-steps .step:nth-child(' + newStep + ')').addClass('active');
        }

        if (slideDirection === 'right') {

          $('.form-steps .step:nth-child(' + (oldStep + 1) + ')').addClass('active').removeClass('ok');

          while ((newStep + 1) < maxSteps) {
            $('.form-steps .step:nth-child(' + (newStep + 1) + ')').removeClass('active ok');
            newStep++;
          }
        }
      });
    }, 100);
  }

  modalShowChilden(parent: string, children: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    $(`#${parent}`).on('hidden.bs.modal', function () {
      $(`#${children}`).modal('show');
      $(`#${parent}`).off('hidden.bs.modal')
    });
    $(`#${parent}`).modal('hide');
  }

 

  modalShow(modalName: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    $("#" + modalName).modal('show');
  }

  lateralMenubarTogglerControl(): void {
    const backdrop = this.renderer.createElement('div');
    this.renderer.addClass(backdrop, 'modal-backdrop');
    this.renderer.addClass(backdrop, 'mbd-lateral-menubar');
    this.renderer.addClass(backdrop, 'fade');
    this.renderer.addClass(backdrop, 'show');
    this.renderer.listen(backdrop, 'click', () => { this.hideLateralMenubarTogglerControl(); });

    const btnActionLateralMenu = document.querySelector('.lateral-menu-bar .btn-action-lateral-menu');
    const modalBackdrop = document.querySelector('.mbd-lateral-menubar');
    const lateralMenuBar = document.querySelector('.lateral-menu-bar');
    const wWidth = window.innerWidth;

    btnActionLateralMenu.classList.toggle('collapse-menu');
    lateralMenuBar.classList.toggle('compact-mode');

    if (992 > wWidth) {
      if (modalBackdrop) {
        modalBackdrop.remove();
      }
      document.body.appendChild(backdrop);
      document.body.classList.toggle('overflow-hidden');
    };

    setTimeout(() => {
      this.updateAllDynamicColWidths();
    }, 220);
  }

  hideLateralMenubarTogglerControl(): void {

    
    const wWidth = window.innerWidth;
    const modalBackdrop = document.querySelector('.mbd-lateral-menubar');
    const lateralMenuBar = document.querySelector('.lateral-menu-bar');

    if (modalBackdrop) {

      this.renderer.removeClass(modalBackdrop, 'show');
      setTimeout(() => {
        modalBackdrop.remove();
      }, 200);
    }

    if (wWidth < 992) {
      this.renderer.removeClass(lateralMenuBar, 'compact-mode');
      this.renderer.removeClass(document.body, 'overflow-hidden');
    } else {
      this.renderer.removeClass(document.body, 'overflow-hidden');
    }
  }

  updateAllDynamicColWidths(): void {
    const colDynamicWidthElements = document.querySelectorAll('.col-dynamic-width');
    colDynamicWidthElements.forEach((element: HTMLElement) => {
      this.colDynamicWidth(element);
    });
  }

  colDynamicWidth(element: HTMLElement): void {
    const wWidth = window.innerWidth;
    const colLateral = element.querySelector('.col-lateral') as HTMLElement;
    const colDynamic = element.querySelector('.col-dynamic') as HTMLElement;
    const dynamicColWidthContainer = element.clientWidth;
    const colLateralWidth = colLateral.clientWidth;
    const newColDynamicMaxWidth = dynamicColWidthContainer - colLateralWidth;
    const newColDynamicMaxWidthPercent = (newColDynamicMaxWidth / dynamicColWidthContainer) * 100;

    if (wWidth >= 992) {
      this.renderer.setStyle(colDynamic, 'flex', `0 0 ${newColDynamicMaxWidthPercent}%`);
      this.renderer.setStyle(colDynamic, 'max-width', `${newColDynamicMaxWidth}px`);
      this.renderer.setStyle(colDynamic, '-webkit-transition', 'all .15s ease-in-out');
      this.renderer.setStyle(colDynamic, 'transition', 'all .15s ease-in-out');
    } else {
      this.renderer.removeStyle(colDynamic, 'flex');
      this.renderer.removeStyle(colDynamic, 'max-width');
      this.renderer.removeStyle(colDynamic, '-webkit-transition');
      this.renderer.removeStyle(colDynamic, 'transition');
    }
  }
}